import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useData } from "../context/DataContext";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn, FaTelegram } from "react-icons/fa";
import { BsTwitterX, BsInstagram } from "react-icons/bs";

function Footer() {
  const { t } = useTranslation();
  const { profile } = useData();
  let date = new Date();
  let year = date.getFullYear();

  const siteName = profile?.settings?.siteName || "Sb.";
  const social = profile?.social || {};

  return (
    <Container fluid className="footer">
      <Container>
        <Row className="align-items-center">
          <Col md="4" className="footer-copywright text-center text-md-start">
            <h3>
              {t("footer_designed", "Designed by")}{" "}
              <span className="purple fw-bold">{siteName}</span>
            </h3>
          </Col>
          <Col md="4" className="footer-copywright text-center">
            <h3>
              {t("footer_copyright", "Copyright ©")} {year}{" "}
              <span className="purple fw-bold">{siteName}</span>
            </h3>
          </Col>
          <Col md="4" className="footer-body">
            <ul className="footer-icons d-flex justify-content-center justify-content-md-end m-0 p-0">
              {social.github && (
                <li className="social-icons">
                  <a
                    href={social.github}
                    style={{ color: "white" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <AiFillGithub />
                  </a>
                </li>
              )}
              {social.twitter && (
                <li className="social-icons">
                  <a
                    href={social.twitter}
                    style={{ color: "white" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsTwitterX />
                  </a>
                </li>
              )}
              {social.linkedin && (
                <li className="social-icons">
                  <a
                    href={social.linkedin}
                    style={{ color: "white" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
              )}
              {social.instagram && (
                <li className="social-icons">
                  <a
                    href={social.instagram}
                    style={{ color: "white" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsInstagram />
                  </a>
                </li>
              )}
              {profile?.contact?.telegram && (
                <li className="social-icons">
                  <a
                    href={profile.contact.telegram}
                    style={{ color: "white" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTelegram />
                  </a>
                </li>
              )}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Footer;
